import { z } from 'zod'
import { UTCMillisecondsSchema } from '../time'
import { CompanyIdSchema, idSchemaV2, isId, UserIdSchema } from '../ids'
import { AuditPropsSchema } from '../common'
import { ArchivableSchema } from '../archive'

export const QuizIdSchema = idSchemaV2('Quiz')
export type QuizId = z.infer<typeof QuizIdSchema>
export type WithQuizId = {
  quizId: QuizId
}
export const isQuizId = isId(QuizIdSchema)

export const QuizSortOptionSchema = z
  .enum(['random', 'sorted'])
  .meta({ description: 'How to sort questions, random by default' })
export type QuizSortOption = z.infer<typeof QuizSortOptionSchema>

export const QuizOptionsSchema = z.object({
  sorting: QuizSortOptionSchema.optional(),
  maxQuestions: z.number().optional(),
  maxMinutesToComplete: z.number().optional(),
  maxAttempts: z.number().optional(),
  minMinutesBetweenAttempts: z.number().optional(),
  minimumScore: z.number().describe('Minimun percent to pass'),
  minimumPercentToRevealWrongQuestions: z.number().min(0).max(100),
})
export type QuizOptions = z.infer<typeof QuizOptionsSchema>

export const UnsavedQuizSchema = z.object({
  title: z.string(),
  ownerId: UserIdSchema,
  editors: UserIdSchema.array(),
  startDate: UTCMillisecondsSchema,
  endDate: UTCMillisecondsSchema,
  options: QuizOptionsSchema,
})
export type UnsavedQuiz = z.infer<typeof UnsavedQuizSchema>

export const QuizDataSchema = z.object({
  ...UnsavedQuizSchema.shape,
  ...ArchivableSchema.shape,
  ...AuditPropsSchema.shape,
  quizId: QuizIdSchema,
  companyId: CompanyIdSchema,
})
export type QuizData = z.infer<typeof QuizDataSchema>
